import { api } from "./base";

export const getPolicy = async ({ locale }) => {
  api.defaults.headers = { locale };
  const res = await api.get("/policy");
  return res.data;
};
